/**
 * Formats a price for display with configurable decimal separator.
 * Whole numbers display without decimals, non-integers show 2 decimal places.
 *
 * @param price - The price to format (number or string)
 * @param decimalSeparator - Decimal separator (e.g. ',' for Dutch, '.' for US). Default: '.'
 * @returns Formatted price string
 *
 * @example
 * formatPrice(65)           // "65"
 * formatPrice(65.00)        // "65"
 * formatPrice(65.50, ',')   // "65,50"
 * formatPrice(65.55)       // "65.55"
 * formatPrice("10.5€", ',') // "10,50" (strips non-numeric chars)
 */
export function formatPrice(
  price: number | string | null | undefined,
  decimalSeparator = '.'
): string {
  if (price === null || price === undefined) {
    return '';
  }

  const numericPrice =
    typeof price === 'string' ? parseFloat(price.replace(/[^0-9.-]/g, '')) : price;

  if (isNaN(numericPrice)) {
    return '';
  }

  const rounded = Math.round(numericPrice * 100) / 100;

  if (Number.isInteger(rounded)) {
    return rounded.toString();
  }

  const formatted = rounded.toFixed(2);
  return formatted.includes('.')
    ? formatted.replace('.', decimalSeparator)
    : formatted;
}

/** @deprecated Use formatPrice instead */
export const formatPriceForDisplay = formatPrice;
